import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DayOfService = /** @class */ (function () {
    function DayOfService(http) {
        this.http = http;
        this.url = '/api/v1/ez/sessions';
        this.log$ = new BehaviorSubject('');
    }
    DayOfService.prototype.ping = function (eventId) {
        var _this = this;
        return this.http
            .get("/api/event/" + eventId + "/ping")
            .pipe(tap(function (res) { return _this.log$.next(res.history); }));
    };
    DayOfService.prototype.getEventStats = function (eventId) {
        return this.http.get("/api/event/" + eventId + "/eventstats");
    };
    DayOfService.prototype.login = function (eventId, payload) {
        return this.http.post("/api/event/" + eventId + "/login", payload);
    };
    DayOfService.prototype.logout = function (eventId) {
        return this.http.post("/api/event/" + eventId + "/logout", null);
    };
    DayOfService.prototype.checkinSearch = function (eventId, payload) {
        return this.http.post("/api/event/" + eventId + "/checkin/search", payload);
    };
    DayOfService.prototype.weighInSearch = function (eventId, payload) {
        return this.http.post("/api/v1/ez/events/" + eventId + "/weighin/search", payload);
    };
    DayOfService.prototype.getChecklist = function (eventId, member_id, member_type) {
        return this.http.get("/api/event/" + eventId + "/checkin/checklist", {
            params: new HttpParams()
                .set('member_id', member_id)
                .set('member_type', member_type),
        });
    };
    DayOfService.prototype.recordChecklist = function (eventId, member_id, member_type, checklist_id, data) {
        var _this = this;
        return this.http
            .post("/api/event/" + eventId + "/checkin/record", {
            member_id: member_id,
            member_type: member_type,
            checklist_id: checklist_id,
            data: data,
        })
            .pipe(tap(function () { return _this.ping(eventId).subscribe(); }));
    };
    DayOfService.prototype.getWeighInDivisions = function (eventId, member_id, member_weight, division_id) {
        return this.http.get("/api/v1/ez/events/" + eventId + "/weighin/divisions", {
            params: new HttpParams()
                .set('member_id', member_id)
                .set('member_weight', member_weight)
                .set('division_id', division_id),
        });
    };
    DayOfService.prototype.recordWeight = function (eventId, member_id, division_id, member_weight) {
        // For debugging
        // return of({
        // 	status: 'RETRY',
        // 	division: {
        // 		id: '3013',
        // 		name: 'World Class Sparring Bantam :: 37.00 - 41.00 :: 12 - 14 :: M',
        // 	},
        // 	weight_ok: false,
        // 	html: 'John NOBLE weight of 32kg is NOT OK and will be rebracketed on second attempt',
        // 	history: '',
        // });
        return this.http.post("/api/v1/ez/events/" + eventId + "/weighin/record", {
            member_id: member_id,
            division_id: division_id,
            member_weight: member_weight,
        });
    };
    DayOfService.prototype.getDivisionResults = function (eventId, divisionId) {
        return this.http.get("/api/event/" + eventId + "/results/divisions/" + divisionId);
    };
    DayOfService.prototype.recordDivisionResults = function (eventId, divisionId, payload) {
        return this.http.post("/api/event/" + eventId + "/results/record/" + divisionId, payload);
    };
    DayOfService.prototype.downloadResults = function (eventId) {
        window.open("/api/event/" + eventId + "/results/export");
    };
    DayOfService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DayOfService_Factory() { return new DayOfService(i0.ɵɵinject(i1.HttpClient)); }, token: DayOfService, providedIn: "root" });
    return DayOfService;
}());
export { DayOfService };
